import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";

const navItems = [
  { path: "/", label: "대시보드", icon: "ri-dashboard-line" },
  { path: "/reports", label: "작업일보", icon: "ri-file-list-3-line" },
  { path: "/report/new", label: "일보 작성", icon: "ri-edit-line" },
  { path: "/statistics", label: "통계", icon: "ri-bar-chart-2-line" }
];

const roleLabel: Record<string, string> = {
  worker: "작업자",
  supervisor: "반장",
  manager: "현장소장",
  safety: "안전관리자",
};

export default function Sidebar() {
  const navigate = useNavigate();
  const location = useLocation();
  const { profile, signOut } = useAuth();

  const handleLogout = async () => {
    await signOut();
    navigate("/login");
  };

  return (
    <aside className="fixed left-0 top-16 bottom-0 w-60 bg-white border-r border-gray-100 z-40 flex flex-col">
      <nav className="flex-1 px-3 py-4 space-y-1 overflow-y-auto">
        {navItems.map((item) => {
          const isActive = location.pathname === item.path ||
            (item.path === "/reports" && location.pathname.startsWith("/report/") && location.pathname !== "/report/new") ||
            (item.path === "/" && location.pathname === "/");

          return (
            <button
              key={item.path}
              onClick={() => navigate(item.path)}
              className={`w-full flex items-center gap-3 px-4 py-2.5 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isActive
                  ? "bg-amber-50 text-amber-700"
                  : "text-gray-600 hover:bg-gray-50 hover:text-gray-900"
              }`}
            >
              <i className={`${item.icon} text-base`}></i>
              {item.label}
            </button>
          );
        })}
      </nav>

      <div className="px-3 py-4 border-t border-gray-100">
        <div className="flex items-center gap-3 px-4 py-2">
          <div className="w-8 h-8 rounded-full bg-amber-100 flex items-center justify-center flex-shrink-0">
            <i className="ri-user-3-fill text-amber-600 text-sm"></i>
          </div>
          <div className="min-w-0 flex-1">
            <p className="text-sm font-medium text-gray-900 truncate">{profile?.name || "사용자"}</p>
            <p className="text-xs text-gray-400 truncate">{roleLabel[profile?.role || "worker"]}</p>
          </div>
          <button
            onClick={handleLogout}
            className="w-8 h-8 rounded-lg hover:bg-gray-100 flex items-center justify-center cursor-pointer transition-colors flex-shrink-0"
            title="로그아웃"
          >
            <i className="ri-logout-box-line text-gray-400 text-base"></i>
          </button>
        </div>
      </div>
    </aside>
  );
}